module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"exportCsvButton":"Daten (CSV)","exportPngButton":"Bild (PNG)"}}')
  delete Component.options._Ctor
}
